import { useSelector } from 'react-redux';
import {
	FiArrowRight,
} from 'react-icons/fi';
import { useState } from 'react';
import StudentPicture from '../../../assets/auth/register/student.svg'
import TutorPicture from '../../../assets/auth/register/teacher.svg'
import Logo from '../../../assets/app/logo.png'
import { useMemo } from 'react';
import { selectTutorProfile } from '../../../store/profile/profileSlice';

const ProfileType = ({setCurrentStep, type, setType}) => {

	const [terms, setTerms] = useState(false);

	const tutorExist = useSelector(selectTutorProfile);
 
	const nextStep = () => {
		if(type === 1) setCurrentStep(1)
		else if(type === 2){
			const canCreateTutor = (tutorExist == undefined || tutorExist.status === undefined || tutorExist.status === -1)
			if(canCreateTutor){
				setCurrentStep(2);
			}else{
				setCurrentStep(10)
			}
		}
	}

	return useMemo(() => <div className='select-none'>
		<img className='m-auto my-10' src={Logo} />
		<h1 className='text-center mb-10 text-nt-blue'>Hello 👋</h1>
		<h2 className='text-center mb-5 text-nt-blue'>Are you a student or a teacher?</h2>
		<div className={"flex justify-around min-h-[150px] sm:min-h-[200px]  "}> 
			<div onClick={() => setType(1)} className={`sm:w-[200px] w-[150px] cursor-pointer rounded-lg relative text-center overflow-hidden border-2 border-solid ${type == 1 ? " border-nt-blue" : "border-nt-grey-light"}`} >
				<img className='p-6' src={StudentPicture}  />
				<span className='bottom-0 left-0 mx-auto absolute w-full'>Student</span>
			</div>
			<div  onClick={() => setType(2)} className={`sm:w-[200px] w-[150px] cursor-pointer rounded-lg relative text-center overflow-hidden border-2 border-solid ${type == 2 ? " border-nt-blue" : "border-nt-grey-light"}`} >
				<img className='p-6' src={TutorPicture} />
				<span className='bottom-0 left-0 mx-auto absolute w-full'>Teacher</span>
			</div>
		</div>
		<p className='flex items-baseline w-full mt-5 text-nt-blue'>
			<input checked={terms} onChange={(v) => setTerms((t) => !t)} className='mr-2' type='checkbox' id='terms' />
			<label className='select-none' htmlFor="terms">I agree to the <a target='_blank' className='text-nt-blue' href='https://ioparla.com/terms-and-conditions/'>Terms and Conditions.</a></label>	
		</p>
		<div className={"w-full flex gap-5 justify-center mt-7"}>
			<button className='w-10 h-10 rounded-full bg-nt-blue flex items-center justify-center disabled:opacity-60' disabled={!terms} onClick={() => nextStep()} >
				<FiArrowRight color="#fff" fontSize={20} />
			</button>
		</div>
	</div>, [terms, type]);

};
export { ProfileType };
